import { Navigate } from "react-router-dom";

const PrivateRouteAgent = ({ children }) => {
  const token = localStorage.getItem("AgentAuthToken");
  const authType = localStorage.getItem("authType");
  return token && authType === "agent" ? children : <Navigate to="/Agent/login" />;
};

export default PrivateRouteAgent;
